<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <span class=" mr-auto">
    <button mat-raised-button routerLink="/sites" class="m-1 mr-2">
      <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('sites.plural', 'Sites') }}
    </button>

    <button mat-raised-button *ngIf="site.parent_site_id" [routerLink]="'/sites/'+site.parent_site_id+'/children'" class="m-1 mr-2">
      <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('child-sites.plural', 'Subsites') }}
    </button>

    <button
      mat-raised-button
      [routerLink]="utils.prepareSiteRelatedLink(site.id, site.parent_site_id, (isViewMode ? 'edit' : 'view') + '/details')"
      *ngIf="site.id && (!isViewMode || canEdit)"
      class="m-1 mr-2">
      <mat-icon>{{ isViewMode ? 'edit' : 'visibility' }}</mat-icon>
      {{ isViewMode ? 'Edit' : 'View' }}
    </button>

    <button *ngIf="site.id && canDelete"
      mat-raised-button
      (click)="onRemove()"
      color="warn"
      class="m-1 mr-2">
      <mat-icon>delete</mat-icon>
      Delete
    </button>
  </span>
</nav>

@if(isViewMode) {
  <app-sites-details-view></app-sites-details-view>
} @else {
  @if (site.id) {
    <mat-tab-group class="bg-white">
      <mat-tab label="Overview">
        <ng-template matTabContent>
          <app-sites-details-edit></app-sites-details-edit>
        </ng-template>
      </mat-tab>
      <mat-tab label="Geofence Map">
        <ng-template matTabContent>
          <app-sites-details-map></app-sites-details-map>
        </ng-template>
      </mat-tab>
      <mat-tab label="Settings">
        <ng-template matTabContent>
          <app-sites-details-settings></app-sites-details-settings>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  } @else {
    <app-sites-details-edit></app-sites-details-edit>
  }
}
